import React, { useState } from 'react';
import './CalculatorPage.css';

function DailyLuckyNumberGenerator() {
  const [date, setDate] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const generateLuckyNumber = (dateString) => {
    // Placeholder for Daily Lucky Number generation logic
    // This is a simplified example; real generation would be more complex.
    const digitsOnly = dateString.replace(/\D/g, '');

    if (digitsOnly.length !== 8) {
      return null; // Invalid length
    }

    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(date)) {
      setError('Please enter a valid date in DD/MM/YYYY format.');
      return;
    }

    const calculated = generateLuckyNumber(date);
    if (calculated === null) {
      setError('Invalid date. Please check your input.');
    } else {
      setResult(calculated);
    }
  };

  const getExplanation = (num) => {
    return `Your Daily Lucky Number is ${num}: This is a placeholder explanation for daily lucky number ${num}.`;
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Daily Lucky Number Generator",
    "description": "Generate your daily lucky number based on the current date.",
    "url": "https://www.yourwebsite.com/daily-lucky-number-generator",
    "potentialAction": {
      "@type": "GenerateAction",
      "name": "Generate Daily Lucky Number",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/daily-lucky-number-generator?date={date}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=date"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Daily Lucky Number Generator</h1>
      <p className="text-center">Enter a date to generate your lucky number for that day.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="date">Date (DD/MM/YYYY):</label>
          <input
            type="text"
            id="date"
            className="form-control"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            placeholder="e.g., 29/07/2025"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Generate Lucky Number</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Your Daily Lucky Number is: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">{getExplanation(result)}</p>
        </div>
      )}
    </div>
  );
}

export default DailyLuckyNumberGenerator;
